import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69909c9df782d50014d938bb_1790606385582_74febefc/frenacal/src/app/partners/page.tsx");
